import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/capacitor';
import { getAppVersionAgeInMonths } from 'shared/getAppVersionAgeInMonths';

export const checkAppIsExpired = async (): Promise<boolean> => {
  if (!Capacitor.isNativePlatform()) {
    return false;
  }

  try {
    const versionAgeInMoths = await getAppVersionAgeInMonths();
    return versionAgeInMoths >= 18;
  } catch (err) {
    Sentry.captureException(err);
    return false;
  }
};
